import { defineStore } from "pinia";

const DEFAULT_TIMEOUT = 15000;

export const useSnackbarStore = defineStore("snackbar", {
  state: () => ({
    visible: false,
    title: "",
    text: "",
    type: "success",
    timeout: DEFAULT_TIMEOUT,
  }),

  actions: {
    show({
      title = "",
      text = "",
      type = "success",
      timeout = DEFAULT_TIMEOUT,
    } = {}) {
      this.title = title;
      this.text = text;
      this.type = type;
      this.timeout = timeout;
      this.visible = true;

      if (timeout > 0) {
        setTimeout(() => {
          this.visible = false;
        }, timeout);
      }
    },

    showSuccess(options = {}) {
      this.show({ ...options, type: "success" });
    },

    showError(options = {}) {
      this.show({ ...options, type: "error" });
    },

    close() {
      this.visible = false;
    },

    clear() {
      this.visible = false;
      this.title = "";
      this.text = "";
      this.type = "success";
    },
  },
});
